/* eslint-disable camelcase */

import React from 'react';

import StylistButtonComponent from 'booking/components/common/StylistButton';

class Stylistlist extends React.Component {
  constructor(props) {
    super(props);
    this.state = { showMore: false };
  }

  showMoreLess = (t) => void this.setState({ showMore: t });
  changeStylist = (s) => void this.props.changeStylist(s);

  render() {
    const { stylistList } = this.props;

    let activeStylists = [];
    let visibleStylists = [];
    activeStylists = stylistList.filter((s) => s.status === 'active').slice();
    if (!this.state.showMore) {
      visibleStylists = activeStylists.slice(0, 9);
    } else {
      visibleStylists = activeStylists.slice();
    }
    let stylistBtn;
    if (visibleStylists.length > 0) {
      stylistBtn = visibleStylists.map((stylist) => {
        let checked = false;

        if (this.props.selectedStylist && this.props.selectedStylist.id === stylist.id) {
          checked = true;
        }

        return stylist.has_column ? (
          <StylistButtonComponent
            name={stylist.user_name}
            service={this.props.service}
            changeStylist={() => this.props.changeStylist(stylist.user_name)}
            key={stylist.user_name}
            checked={checked}
            selectedStylist={this.props.selectedStylist}
            activeStylists={visibleStylists}
          />
        ) : null;
      });
    }

    return (
      <div className="stylist-list">
        <div className="list-container">{stylistBtn}</div>

        {!this.state.showMore && activeStylists.length > 9 && (
          <div className="more-less-btn" onClick={() => this.showMoreLess(true)} role="button" tabIndex="-3">
            <p>More</p>
          </div>
        )}
      </div>
    );
  }
}

export default Stylistlist;
